import { render, staticRenderFns } from "./month.vue?vue&type=template&id=3edca691&"
import script from "./month.vue?vue&type=script&lang=ts&"
export * from "./month.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports